import { t } from "@impero-com/common/utils/i18n";
import { queryClient } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";

import { UserTagCategoryWithTagsView } from "api/generated/model";
import { usePostTagCategories } from "api/generated/tags/tags";

import { TAGS_QUERY_KEY } from "./useTagsQuery";

export const useCreateTagCategoryMutation = (
    onCreated: (createdCategory: UserTagCategoryWithTagsView) => void
) =>
    usePostTagCategories({
        mutation: {
            onSuccess: ({ data }) => {
                const notification = t(
                    "TagsList_CreateCategoryDrawer_Notification_TagCategoryCreated",
                    { tagCategoryName: data.category.name }
                );
                emitNotification("success", notification);
                onCreated(data);
                queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY });
            },
            onError: () => {
                emitNotification(
                    "error",
                    t(
                        "TagsList_CreateCategoryDrawer_Notification_CreateTagCategoryFailed"
                    )
                );
            },
        },
    });
